<template>
  <div id="site-header">
    <nav class="navbar navbar-expand-md site-navbar fixed-top" :class="{ 'on-scroll': !view.topOfPage }">
      <div class="container">
        <div class="navbar-brand ms-4" @click="gotoHome()">
          <img src="../assets/images/logo.png" width="130">
        </div>

        <button class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false">
          <span class="navbar-toggler-icon custom-color"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto header-menu">
            <li class="nav-item header-menu-item">
              <a class="navbar-link me-3" href="javascript:void()" @click="goto('product-holder')">Soluções</a> <!-- href="partners" Quando tiver a página -->
            </li>
            <li class="nav-i;tem header-menu-item">
              <a class="navbar-link me-3" target="_blank" href="https://central.bytecom.inf.br">Central de Apoio</a>
            </li>
            <li class="nav-item header-menu-item">
              <a class="navbar-link me-3" href="javascript:void()" @click="goto('contacts-holder')">Contato</a>
            </li>
            <li class="nav-item header-menu-item">
              <a class="navbar-link me-3" href="/partners">Parceiros</a>
            </li>
            <li class="nav-item header-menu-item">
              <a class="navbar-link me-3" href="javascript:void()" @click="goto('contacts-holder')">Trabalhe Conosco</a>
            </li>
           <!-- <li class="nav-item header-menu-item">
               <a class="navbar-link me-3" href="/terms-of-use">Termos de Uso</a> 
              <a class="navbar-link me-3" href="/">Termos de Uso</a> 
            </li>
            <li class="nav-item header-menu-item">
               <a class="navbar-link me-3" href="/privacy-policy">Política de Privacidade</a>
              <a class="navbar-link me-3" @click="PaginaInicial">Política de Privacidade</a>
            </li>-->
            <li class="nav-item header-menu-item">
              <a class="navbar-link me-3" href="/terms-of-use">Termos de Uso</a>
              <!-- <a class="navbar-link me-3" @click="IrParaTermosDeUso">Termos de Uso</a>  -->
            </li>
            <li class="nav-item header-menu-item">
              <a class="navbar-link me-3" href="/privacy-policy">Política de Privacidade</a>
              <!-- <a class="navbar-link me-3" @click="IrParaPoliticaDePrivacidade">Política de Privacidade</a> -->
            </li>

            
          </ul>
        </div>

      </div>
    </nav>
    <div class="container">
      <div class="row">
        <div class="col-4 apresentation-holder">
          <p class="text-left lh-1 fw-bold" id="apresentation-text-heading"></p>
          <p class="text-left" id="apresentation-text-body">Conheça mais sobre nossa marca e fique por dentro de tudo sobre nossos produtos.</p>
          <button type="button" class="btn ps-4 pe-4" id="apresentation-btn-first" @click="goto('product-holder')">Soluções</button>
          <button type="button" class="btn ps-4 pe-4" id="apresentation-btn-second" @click="goto('contacts-holder')">Fale Conosco</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NavBar',
  components: {
  },
  data () {
    return { 
      view: {
        topOfPage: true,
      },
    }
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted () {
    var aText = ["Nossa solução, sua gestão."];
    var iSpeed = 80;
    var iIndex = 0;
    var iArrLength = aText[0].length;
    var iScrollAt = 10;
    var iTextPos = 0;
    var sContents = '';
    var iRow;

    function typewriter () {
      sContents =  ' ';
      iRow = Math.max(0, iIndex - iScrollAt);
      var destination = document.getElementById("apresentation-text-heading");
      
      while ( iRow < iIndex ) {
        sContents += aText[iRow++] + '<br />';
      }
      destination.innerHTML = sContents + aText[iIndex].substring(0, iTextPos) + "|";
      if ( iTextPos++ == iArrLength ) {
        iTextPos = 0;
        iIndex++;
        destination.innerHTML = destination.innerHTML.substring(0, destination.innerHTML.length - 1)
        if ( iIndex != aText.length ) {
          iArrLength = aText[iIndex].length;
          setTimeout(function () {
            typewriter()
          }, 500);
        }
      } else {
        setTimeout(function() {
          typewriter()
        }, iSpeed);
      }
    }

    typewriter();
  },
  methods: {
    IrParaPoliticaDePrivacidade() {
      this.$router.push('/privacy-policy')
    },
    IrParaTermosDeUso() {
      this.$router.push('/terms-of-use')
    },
  
    gotoHome() {
      window.location = "/";
    },

    goto(referencia) {
      var el = document.getElementById(referencia)
      window.scrollTo({
        top: el.offsetTop,
        behavior: "smooth",
      });
    },
    handleScroll () {
      if (window.scrollY > 0) {
        if (this.view.topOfPage) this.view.topOfPage = false
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true
      }
    }
  }
}
</script>

<style scoped>

.custom-color {
  background-image: url("../assets/images/mobile-hamburguer-svg.svg") !important;
}

.navbar-toggler {
  border-color: rgba(255, 255, 255, 0.658);
}

#site-header {
  background-size: cover;
  background-image: url("../assets/images/banner.gif");
  opacity: 1;
  height: 600px;
  display: flex;
  font-family: Montserrat Regular;
}

.navbar-brand {
  cursor: pointer;
}

.site-navbar {
  background: rgb(50,50,50);
  background: linear-gradient(180deg, rgba(50,50,50,0.65) 60%, rgba(255,255,255,0) 100%);
  -moz-box-shadow: none;
  -goog-ms-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  transition: .2s ease;
}

.apresentation-holder {
  background-image: linear-gradient(to right, #5c6ba76c, #fb7049af);
  margin: 100px 0 0 170px;
  color: #fff;
  
  width: 400px;
  padding: 20px;
  font-family: Montserrat Regular;
}

.apresentation-holder p {
  filter: drop-shadow(1px 1px rgba(122, 121, 121, 0.575));
}

.apresentation-holder mark {
  color: #fff;
  padding: 0;
}

#apresentation-text-heading {
  font-size: 3rem;
  font-family: Montserrat Medium;
  width: 107%;
  height: 170px;
}

#apresentation-text-body {
  font-size: 1.5rem;
  line-height: 23px;
  font-family: Montserrat Regular;
}

#apresentation-btn-first {
  background-image: linear-gradient(to right, #4258b1 0%, #eb5429  51%, #4258b1  100%);
  margin: 5px 5px 5px 0;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  box-shadow: 0 0 5px rgba(238, 238, 238, 0.336);
  border-radius: 20px;
}

#apresentation-btn-second {
  background-color: #ffffff;
  margin: 5px;
  transition: 0.5s;
  background-size: 200% auto;
  color: #fb7149;
  box-shadow: 0 0 5px rgba(238, 238, 238, 0.336);
  border-radius: 20px;
  font-weight: bold;
}

.navbar-link {
  font-size: 1rem;
  color: #ffffff;
  text-decoration: none;
  padding-bottom: 2px;
  --bg-h: 2px;
}

.on-scroll {
  background-color: #333333;
  box-shadow: 0px 2px 5px #777;
}

a {
  background: linear-gradient(0deg, rgb(255, 255, 255), rgb(255, 255, 255)) no-repeat right bottom / 0 var(--bg-h);
  transition: background-size 350ms;
  --bg-h: 100%;
}

a:where(:hover, :focus-visible) {
  background-size: 100% var(--bg-h);
  background-position-x: left;
}

@media (min-width: 1400px) {
  .navbar-link {
    margin: 10px;
  }
}

@media (max-width: 1150px) {
  .navbar-link {
    font-size: 0.8rem;
  }

  #site-header {
    height: 500px;
  }

  #apresentation-text-heading {
    font-size: 2rem;
    height: 100px;
  }

  #apresentation-text-body {
    font-size: 1rem;
  }

  .apresentation-holder {
    width: 300px;
  }

  #apresentation-btn-second, #apresentation-btn-first  {
    font-size: 0.625rem;
  }
}

@media (max-width: 772px) {
  .apresentation-holder {
    margin: 100px auto;
  }

  .container {
    background-size: 100% 100%;
  }
}

</style>
